import { cx } from '@linaria/core';
import { memo, useRef, useId } from 'react';
import { getTools, AccessCodes } from '@pm2/api';
import { useLeaveRevision, useCurrentCourseDescriptor } from '@pm2/course-revisions';
import { withSuspenseCache } from '@pm2/react-utils';
import { pm2ConfigStore } from '@pm2/store';
import { breakpoints } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { ToolboxIcon } from '@ui/kit/icons';
import { useMatchBreakpoint, useForceHeaderExpanded, useScrollLocking } from '@utils/react';
import { ToolboxDropdown } from './atom.dropdown.js';
import { toolboxButton } from './root.toolbox.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { toolButtonCls } from '../root.tools.style.js';

const ToolboxNonMemoized = ({
  enabled,
  onEnable,
  onDisable
}) => {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownId = useId();
  const portalId = pm2ConfigStore.useSelector(state => state.config.id);
  const previewMode = pm2ConfigStore.useSelector(state => state.previewMode);
  const leaveRevision = useLeaveRevision(useCurrentCourseDescriptor());
  const tools = withSuspenseCache(getTools(portalId, {
    previewMode
  })).filter(tool => tool.accessCode === AccessCodes.ALLOWED);
  useForceHeaderExpanded(!isMobile && enabled);
  useScrollLocking(!isMobile && enabled);
  const handleButtonClick = async () => {
    if (!enabled) {
      const intent = await leaveRevision();
      if (intent === "cancel") {
        return;
      }
      onEnable();
    } else {
      onDisable();
    }
  };
  const handleClose = () => {
    onDisable();
  };
  if (tools.length === 0) {
    // hide the button if there are no portal tools available to show inside
    // the dropdown
    return null;
  }
  return /*#__PURE__*/jsx(Tooltip, {
    containerRef: buttonRef,
    placement: "bottom",
    offsetPx: 0,
    body: "\xC5bn v\xE6rkt\xF8jer tilknyttet portalen",
    ariaType: "label",
    disabled: enabled,
    children: ref => /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("button", {
        ref: ref,
        className: cx(toolButtonCls, toolboxButton),
        onClick: handleButtonClick,
        "aria-expanded": enabled,
        "aria-controls": dropdownId,
        children: /*#__PURE__*/jsx(ToolboxIcon, {
          height: 26
        })
      }), /*#__PURE__*/jsx(ToolboxDropdown, {
        id: dropdownId,
        tools: tools,
        buttonRef: buttonRef,
        dropdownRef: dropdownRef,
        open: enabled,
        onClose: handleClose
      })]
    })
  });
};
const Toolbox = /*#__PURE__*/memo(ToolboxNonMemoized);

export { Toolbox };
//# sourceMappingURL=root.toolbox.js.map
